import { Sprout } from 'lucide-react';
import { type ReactNode } from 'react';

import { cn } from '@apps/web/lib/utils';

/**
 * Tag marking training-mode surfaces (page header, chat panel). Text uses the
 * stronger shade: the base green does not meet contrast on the tinted
 * background.
 */
export function TrainingModeBadge({
    children,
    className,
}: {
    readonly children: ReactNode;
    readonly className?: string;
}) {
    return (
        <span
            className={cn(
                'border-training/20 bg-training/[0.06] text-training-strong inline-flex shrink-0 items-center gap-1 rounded-md border px-1.5 py-0.5 text-[11px] font-medium',
                className,
            )}
        >
            <Sprout className="h-3 w-3" />
            <span data-training-mode-badge-label="true">{children}</span>
        </span>
    );
}
